import type { ProtocolStep } from "../../../../../../types/lab/ProtocolTypes";
import { AUTO_STEP_TYPES } from "./stepMeta";

const STARTED_STATUSES = new Set(["in_progress", "failed", "timed_out", "requires_rework"]);

export function canOpenStep(
	step: ProtocolStep,
	gsiStatus: string | undefined,
	groupStatus: string,
	activeStepNumbers: number[],
): boolean {
	// Checked before the group gate so a held, failed or finished group's history stays readable.
	if (gsiStatus === "completed") return true;
	if (AUTO_STEP_TYPES.has(step.step_type)) return false;
	if (groupStatus !== "active") return STARTED_STATUSES.has(gsiStatus ?? "");
	if (activeStepNumbers.includes(step.step_number)) return true;
	return gsiStatus === "in_progress";
}
